import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import autobind from 'autobind-decorator';
import { Link } from 'react-router-dom';

import { DataTableView, Column } from 'src/core/ui/data-table.view';
import { OptionsDialogView } from 'src/core/ui/options-dialog.view';
import { TextView } from 'src/core/ui/text.view';
import { RegionEditorController } from 'src/app/general/regions/parts/region-editor.controller';
import { PlaceEditorController } from 'src/app/general/places/parts/place-editor.controller';
import { ProductCategoryEditorController } from 'src/app/products/product-categories/parts/product-category-editor.controller';
import { ProductTypeEditorController } from '../parts/product-type-editor.controller';

interface ProductListViewState {
	regionFilter?: number;
}

@observer
export class ProductListView extends React.Component<ProductListViewProps, ProductListViewState> {
	public state: ProductListViewState = {};

	private options = [
		{
			key: 'General',
			text: 'General',
			checked: true
		},
		{
			key: 'Accomodation',
			text: 'Accomodation'
		},
		{
			key: 'CarRent',
			text: 'Car Rent'
		},
		{
			key: 'Transfer',
			text: 'Transfer'
		},
		{
			key: 'Flight',
			text: 'Flight'
		},
		{
			key: 'Tour',
			text: 'Tour'
		},
	]

	constructor(props: any) {
		super(props);
	}

	@observable
	showDialog = false;

	@autobind
	private createNew() {
		this.showDialog = true;
		return Promise.resolve(null);
	}

	@autobind
	private closeDialog(selectedValue?: string) {
		if (selectedValue) {
			this.props.onItemDoubleClicked(selectedValue as any);
		}
		this.showDialog = false;
	}

	render() {
		const model = this.props.model;
		const items = model.items.map(o => o);
		const columns: Column[] = [
			{
				key: 'displayName',
				title: 'Name',
				dataIndex: 'displayName',
				render: (text, record: ProductSummary) => <Link to={`/products/products/${record.id}`}>{text}</Link>,
			},
			{
				key: 'code',
				title: 'Code',
				dataIndex: 'code',
				filter: {
					field: 'code',
					type: 'string',
					render: (value, onChange) => (
						<TextView
							mode='edit'
							label={null}
							value={value}
							onChanged={onChange}
						/>
					)
				}
			},
			{
				key: 'productType',
				title: 'Type',
				dataIndex: 'productTypeText',
				filter: {
					field: 'productType',
					type: 'foreignKey',
					render: (value, onChange) => (
						<ProductTypeEditorController
							label={null}
							mode='edit'
							value={value}
							onChanged={onChange}
							setBusy={this.props.setBusy}
						/>
					)
				}
			},
			{
				key: 'categoryDisplayName',
				title: 'Category',
				dataIndex: 'categoryDisplayName',
				filter: {
					field: 'categoryId',
					type: 'foreignKey',
					render: (value, onChange) => (
						<ProductCategoryEditorController
							label={null}
							mode='edit'
							value={value}
							onChanged={(newValue) => { onChange(newValue != null ? newValue.id : null); }}
							setBusy={this.props.setBusy}
						/>
					)
				}
			},
			{
				key: 'regionDisplayName',
				title: 'Region',
				dataIndex: 'regionDisplayName',
				filter: {
					field: 'regionId',
					type: 'foreignKey',
					render: (value, onChange) => (
						<RegionEditorController
							label={null}
							mode='edit'
							value={value}
							onChanged={(newValue) => {
								const id = newValue != null ? newValue.id : null;
								onChange(id);
								this.setState({
									regionFilter: id,
								});
							}}
							setBusy={this.props.setBusy}
						/>
					)
				}
			},
			{
				key: 'placeDisplayName',
				title: 'Place',
				dataIndex: 'placeDisplayName',
				filter: {
					field: 'placeId',
					type: 'foreignKey',
					render: (value, onChange) => (
						<PlaceEditorController
							label={null}
							mode='edit'
							value={value}
							onChanged={(newValue) => { onChange(newValue != null ? newValue.id : null); }}
							setBusy={this.props.setBusy}
							regionId={this.state.regionFilter}
						/>
					)
				}
			}
		];

		return (
			<div className="window window-normal">
				<OptionsDialogView
					closeDialog={this.closeDialog}
					options={this.options}
					showDialog={this.showDialog}
					title='Choose a type'
					subtitle='You can choose between a several product types.'
				/>
				<div className="panel">
					<DataTableView
						setBusy={this.props.setBusy}
						columns={columns}
						model={model}
						createNewItem={this.createNew}
						itemDoubleClick={(item) => { if (this.props.onItemDoubleClicked) { this.props.onItemDoubleClicked(item); } }}
						hierarchyParent={['parentProductId']}
						hierarchyHasChildren={(item) => item.hasChildren}
						hierarchyId={['id']}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/products/list/product-list.view.tsx